module.exports = __webpack_public_path__ + "images/4363f0c5abd3c7344faeb30f2982176721.svg";